import api from '../../lib/api';

type ErrorResult = {
  ok: false;
  status: number;
  message: string;
};

export type PasswordLoginSuccess = {
  customer_id: number;
  name: string;
  tel: string | null;
  auth_token: string;
};

const extractErrorMessage = (error: any, fallback: string): string =>
  error?.response?.data?.error || fallback;

export const loginCustomerWithPassword = async (
  tel: string,
  password: string
): Promise<{ ok: true; data: PasswordLoginSuccess } | ErrorResult> => {
  try {
    const res = await api.post<PasswordLoginSuccess>(
      '/api/customer-app/auth/login',
      { tel, password }
    );
    return { ok: true, data: res.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 500,
      message: extractErrorMessage(error, 'Failed to log in'),
    };
  }
};
